module.exports = __webpack_public_path__ + "static/img/MidJourney-copy.8484ce27.png";